export default Object.freeze({
  $yellow: "#efb43e",
});
